import React, { useRef } from 'react';

import ModalVideo from '../ModalVideo';
import { Implanon_Title } from '../../../../../utils/EN/Modals/SocialModals';

const ModalSocialImplanon = () => {
  return (
    <>
      <ModalVideo
        id="implanon-social"
        dataText={Implanon_Title}
        videoSrc="https://player.vimeo.com/video/644945448?h=6b5cafa66c&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
        videoTitle="KUTER_STUDIO_IMPLANON_NXT"
      />
    </>
  );
};

export default ModalSocialImplanon;
